import { render, staticRenderFns } from "./ReservationOptions.vue?vue&type=template&id=55a16f12"
import script from "./ReservationOptions.vue?vue&type=script&lang=js"
export * from "./ReservationOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports